import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from 'react-redux';
import { updateWebhook, createWebhook } from "../../slices/webhooks";
import { useNavigate } from 'react-router-dom';

import { convertErrorsFromServer } from '../../utils'

const translations = [
    gettext('Event'),
    gettext('Select event'),
    gettext('Url'),
    gettext("Save"),
]


const WebhookForm = ({ webhook, events }) => {

    const dispatch = useDispatch()
    const navigate = useNavigate()


    const {
        register,
        handleSubmit,
        reset,
        watch,
        setValue,
        setError,
        formState: { errors }
    } = useForm({
        defaultValues: {
            event: webhook?.event || "",
            url: webhook?.url
        }
    });

    const onSubmit = (data) => {
        if (webhook) {
            Promise.resolve(dispatch(updateWebhook({ id: webhook.id, args: data })))
            .then(data => {
                if (data.meta.requestStatus === "rejected") {
                    convertErrorsFromServer(data.payload).forEach(({name, type, message}) => {
                        setError(name, { type, message })
                    })
                } else {
                    navigate('/settings/webhooks/')
                }
            })
        } else {
            Promise.resolve(dispatch(createWebhook(data)))
            .then(data => {
                if (data.meta.requestStatus === "rejected") {
                    convertErrorsFromServer(data.payload).forEach(({name, type, message}) => {
                        setError(name, { type, message })
                    })
                } else {
                    navigate('/settings/webhooks/')
                }
            })
        }
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className="contentarea clamped">
                <div className="container-fluid detail">
                    <div className="row">
                        <div className="col-12 mb-4">
                            <label>{gettext('Event')}</label>
                            <select {...register("event")} className={`form-select ${errors.event && "is-invalid"}`}>
                                {!webhook &&
                                    <option value="">{gettext('Select event')}</option>
                                }
                                {events.map((event, index) => (
                                    <option key={index} value={event[0]}>{event[1]}</option>
                                ))}
                            </select>
                            {errors.event && <div className="invalid-feedback">{errors.event.message}</div>}
                        </div>
                        <div className="col-12 mb-4">
                            <label>{gettext('Url')}</label>
                            <input type="text" {...register("url")} className={`form-control ${errors.url && "is-invalid"}`} />
                            {errors.url && <div className="invalid-feedback">{errors.url.message}</div>}
                        </div>
                    </div>
                </div>
            </div>
            <div className="clamped text-end">
                <input className="btn btn-primary mt-4 ms-auto" type="submit" value={gettext("Save")} />
            </div>
        </form>
    )
}

export default WebhookForm